module.exports = __webpack_public_path__ + "img/thumbnail_WhiteFacedSaki_m_normal.b0f67c5e.png";